import React from 'react'
import { ContentItem, ContentPathEntry } from '@antegma/accallio-cloud-hootsuite-application-api-javacript-sdk'
import { Masonry } from '~/components/masonry'
import MediaCardView from '~/components/media-cardview'

type TProps = {
  items: ContentItem[]
  currentFolderPath?: ContentPathEntry[]
}
const CollectionMasonry: React.FunctionComponent<TProps> = ({ items, currentFolderPath }) => {
  console.log('MediaMasonry - Received currentFolderPath:', currentFolderPath)
  const itemToElement = (item: ContentItem): JSX.Element => <MediaCardView key={item.id} contentItem={item} currentFolderPath={currentFolderPath} />

  return <Masonry>{items.map(itemToElement)}</Masonry>
}

export default React.memo(CollectionMasonry)
